<template>
  <div id="app">
    <Welcome/>
  </div>
</template>

<script>
import Welcome from "./components/Welcome.vue";

export default {
  name: "app",
  components: {
    Welcome
  },
  data() {
    return {
      test: 0
    };
  }
};
</script>

<style>
html,
body {
  height: 100%;
  background-color: #fff;
  font-family: "Work Sans", sans-serif;
}

body {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  color: #000;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 600;
}

#app {
  width: 100%;
  margin: auto;
}

a,
a:focus,
a:hover {
  text-decoration: underline;
  color: #000;
}

a {
  color: #6c757d;
}

.form-control:focus,
.custom-select:focus {
  border-color: #6c757d;
  box-shadow: inset 0 1px 1px rgba(108, 117, 125, 0.5),
    0 0 8px rgba(108, 117, 125, 0.5);
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
</style>
